var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAegCards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 68,
    viewBox: "0 0 60 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_908_171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1449 21.0023C42.1449 21.686 42.1617 22.3698 42.1375 23.0524C42.126 23.3743 42.2438 23.5047 42.5456 23.6046C44.4727 24.24 46.3734 24.9647 48.3214 25.5264C49.7572 25.9398 50.321 27.1273 49.8214 28.5663C47.6577 34.7975 45.5908 41.0614 43.4881 47.3136C42.5562 50.0832 41.62 52.8506 40.6891 55.6202C40.2663 56.8772 39.3133 57.3684 38.0552 56.9466C32.2342 54.9912 26.4143 53.0294 20.5943 51.0709C20.0137 50.8752 19.4268 50.6985 18.8535 50.4839C17.7774 50.0811 17.2904 49.1207 17.667 48.0394C17.8753 47.4409 17.8931 46.8445 17.8963 46.2313C17.8974 45.9599 17.8321 45.8578 17.5324 45.9199C17.2105 45.9862 16.8844 46.0766 16.5457 46.0304C15.6411 45.9083 15.0174 45.3182 14.8627 44.4052C14.0623 39.6761 13.2671 34.9448 12.4687 30.2145C11.6661 25.4675 10.8646 20.7204 10.0568 15.9744C9.79906 14.4576 10.4176 13.613 11.9364 13.3595C17.4282 12.4423 22.9168 11.5093 28.4065 10.5826C29.512 10.3964 30.6165 10.2071 31.722 10.0272C32.777 9.85575 33.7237 10.509 33.9193 11.585C34.2191 13.2385 34.4947 14.8973 34.7545 16.5572C34.8113 16.9201 34.927 17.0505 35.3141 17.0452C36.9087 17.021 38.5033 17.0316 40.098 17.0368C41.3728 17.041 42.1291 17.7899 42.1428 19.0574C42.1501 19.7054 42.1438 20.3544 42.1438 21.0023H42.1449ZM19.29 33.5458C19.29 38.3107 19.29 43.0757 19.29 47.8406C19.29 48.5864 19.391 48.6863 20.141 48.6863C26.7277 48.6863 33.3145 48.6863 39.9013 48.6863C40.6481 48.6863 40.748 48.5853 40.748 47.8354C40.748 38.3234 40.748 28.8114 40.748 19.2994C40.748 18.5136 40.6649 18.4316 39.8708 18.4316C33.3019 18.4316 26.7319 18.4316 20.1631 18.4316C19.3721 18.4316 19.2911 18.5126 19.2911 19.3036C19.2911 24.0506 19.2911 28.7977 19.2911 33.5458H19.29ZM17.8952 31.5062C17.8952 27.425 17.8952 23.3438 17.8952 19.2615C17.8952 17.7384 18.5916 17.0368 20.1031 17.0368C24.3779 17.0368 28.6516 17.0316 32.9264 17.0452C33.3303 17.0463 33.4344 16.9621 33.3576 16.5488C33.081 15.052 32.8443 13.5478 32.5866 12.0468C32.4835 11.4483 32.3289 11.3483 31.7346 11.4483C25.2635 12.5391 18.7925 13.6298 12.3204 14.7164C11.3411 14.8805 11.3022 14.9394 11.4642 15.8955C12.3256 20.9676 13.1797 26.0408 14.037 31.1128C14.766 35.4265 15.4981 39.7402 16.2196 44.055C16.2912 44.4799 16.4773 44.664 16.9244 44.6156C17.8921 44.5104 17.8952 44.523 17.8952 43.9077C17.8952 39.7739 17.8952 35.6401 17.8952 31.5062ZM42.1449 46.5573L42.2448 46.5752C42.2743 46.4963 42.3069 46.4185 42.3342 46.3385C44.4095 40.1915 46.4838 34.0444 48.5581 27.8973C48.7537 27.3167 48.6801 27.141 48.1089 26.9454C46.3218 26.3342 44.5316 25.7336 42.7402 25.1341C42.1491 24.9363 42.1459 24.9437 42.1459 25.5516C42.1459 32.4182 42.1459 39.2848 42.1459 46.1513V46.5573H42.1449ZM22.3772 50.019L22.3678 50.1726C22.4961 50.222 22.6223 50.2757 22.7517 50.3198C28.0026 52.0922 33.2545 53.8604 38.5033 55.6412C38.9935 55.8074 39.2186 55.6223 39.3638 55.1826C39.8581 53.689 40.3651 52.1995 40.8616 50.7059C40.9416 50.4671 41.0783 50.2389 41.0762 50.0201H22.3762L22.3772 50.019Z",
    fill: "url(#paint0_linear_908_171)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_908_171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3567 33.9865V33.8109C34.762 32.0543 34.762 29.595 34.0593 27.8384C33.8837 28.7167 33.5323 30.122 32.4784 32.0543C31.7757 30.2976 30.7218 28.3654 30.0191 26.4331C29.3165 28.3654 28.2625 30.2976 27.5599 32.0543C26.5059 30.122 26.1546 28.7167 25.9789 27.8384C25.2763 29.595 25.2763 32.0543 26.6816 33.8109C26.8572 33.9865 26.6816 33.9865 26.6816 33.9865C25.9789 35.7431 24.0466 39.0807 23.344 40.6616C23.6953 40.486 24.2223 40.3103 24.5736 40.1347C25.2763 39.7833 25.6276 39.2564 25.9789 38.905C26.6816 37.6754 27.2085 36.9728 27.7355 35.7431C28.4382 36.7971 29.3165 38.0267 30.0191 39.0807C30.7218 38.0267 31.6001 36.9728 32.3027 35.7431C32.8297 36.9728 33.181 37.6754 34.0593 38.905C34.4106 39.2564 34.762 39.7833 35.4646 40.1347C35.8159 40.3103 36.3429 40.486 36.6942 40.6616C35.9916 39.0807 34.0593 35.7431 33.3567 33.9865ZM30.0191 35.7431L28.7895 33.8109L30.0191 31.176L31.2487 33.8109L30.0191 35.7431Z",
    fill: "url(#paint1_linear_908_171)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_908_171",
    x: 0,
    y: 0,
    width: 60,
    height: 67.0945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.623529 0 0 0 0 0.313726 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_908_171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_908_171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_908_171",
    x: 13.344,
    y: 16.4331,
    width: 33.3503,
    height: 34.2285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.623529 0 0 0 0 0.313726 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_908_171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_908_171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_908_171",
    x1: 8.60591,
    y1: -104.372,
    x2: -9.21276,
    y2: -102.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355731,
    stopColor: "#B1895F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854697,
    stopColor: "#986530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_908_171",
    x1: 22.8787,
    y1: -8.12187,
    x2: 16.948,
    y2: -7.38301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355731,
    stopColor: "#B1895F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854697,
    stopColor: "#986530"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAegCards);
export default __webpack_public_path__ + "static/media/aeg_cards.243271948bddb551053eb430405478a6.svg";
export { ForwardRef as ReactComponent };